import { useEffect, useState } from 'react';
import { Box, Typography, Stack, CircularProgress } from '@mui/material';
import { motion } from 'framer-motion';
import { CardSurface } from '../../ui/CardSurface';

export function LoadingEmpresaScreen({ 
  mode = 'default', // 'script', 'auth', 'location', 'default'
  obtendoGeolocalizacao = false 
}) {
  const [startTime] = useState(Date.now());
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    console.log('[LoadingEmpresaScreen] Componente montado');
    const interval = setInterval(() => {
      setElapsed(Math.floor((Date.now() - startTime) / 1000));
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  // Modo script: apenas spinner, sem texto
  if (mode === 'script') {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.default',
        }}
      >
        <CircularProgress size={48} sx={{ color: 'primary.main' }} />
      </Box>
    );
  }

  // Modo auth: verificando usuário
  if (mode === 'auth') {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.default',
          px: 2,
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          style={{ width: '100%', maxWidth: 400 }}
        >
          <CardSurface sx={{ p: 4, textAlign: 'center' }}>
            <Stack spacing={3} alignItems="center">
              <CircularProgress size={48} sx={{ color: 'primary.main' }} />
              <Typography variant="h6" fontWeight={600}>
                Verificando usuário conectado...
              </Typography>
            </Stack>
          </CardSurface>
        </motion.div>
      </Box>
    );
  }

  // Modo location: obtendo localização
  if (mode === 'location' || obtendoGeolocalizacao) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.default',
          px: 2,
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          style={{ width: '100%', maxWidth: 400 }}
        >
          <CardSurface sx={{ p: 4, textAlign: 'center' }}>
            <Stack spacing={3} alignItems="center">
              <CircularProgress size={48} sx={{ color: 'primary.main' }} />
              <Box sx={{ width: '100%' }}>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  Obtendo localização...
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Aguardando permissão de geolocalização do dispositivo
                </Typography>
              </Box>
            </Stack>
          </CardSurface>
        </motion.div>
      </Box>
    );
  }

  // Modo default: carregando empresa
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        px: 2,
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        style={{ width: '100%', maxWidth: 400 }}
      >
        <CardSurface sx={{ p: 4, textAlign: 'center' }}>
          <Stack spacing={3} alignItems="center">
            <CircularProgress size={48} sx={{ color: 'primary.main' }} />
            <Box sx={{ width: '100%' }}>
              <Typography variant="h6" fontWeight={600} gutterBottom>
                Carregando empresa...
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Tempo: {elapsed}s
              </Typography>
            </Box>

            {elapsed > 10 && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
              >
                <CardSurface
                  sx={{
                    p: 2,
                    bgcolor: 'warning.light',
                    border: '1px solid',
                    borderColor: 'warning.main',
                    mt: 2,
                  }}
                >
                  <Typography variant="body2" color="warning.dark" sx={{ fontSize: '0.875rem' }}>
                    ⚠️ Carregamento está demorando. Verifique o console (F12) para mais informações.
                  </Typography>
                </CardSurface>
              </motion.div>
            )}
          </Stack>
        </CardSurface>
      </motion.div>
    </Box>
  );
}
